import React from 'react';
import { IconButton, Box } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MenuIcon from '@mui/icons-material/Menu';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred';

export default function IconOverlay(props) {
    const { isLocked, highlighted } = props

    return (
        <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <IconButton>
                <MenuIcon sx={{ color: 'white' }} />
            </IconButton>
            <IconButton
                sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    transform: 'translate(-180%, 0%)',
                    borderRadius: '50%',
                    width: 8,
                    height: 8,
                    '&:hover': {
                        '& .MuiSvgIcon-root': {
                            fontSize: 24,
                            color: 'rgba(177, 236, 175, 0.9)'
                        },
                    },
                }}
            >
                {isLocked
                ?
                    <LockIcon sx={{ fontSize: highlighted ? 24 : 14, color: highlighted ? 'rgba(177, 236, 175, 0.9)' : 'rgba(255, 255, 255, 0.3)' }} />
                :
                    <NoEncryptionGmailerrorredIcon sx={{ fontSize: highlighted ? 24 : 14, color: highlighted ? 'rgba(177, 236, 175, 0.9)' : 'rgba(255, 255, 255, 0.3)' }} />
                }
            </IconButton>
        </Box>
    );
}